
























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ContentCategory, IContent, INarrative, IScenario } from '../models';
import { CollectionNames, CollectionNamesArr } from '../services/meiosis';
import { CollectionsModel, CollectionType } from '../services/states/collection-state';
import { capitalize, random } from 'lodash';
import { render } from 'slimdown-js';
import { htmlTemplate, cssTable } from '@/assets/html-styles';

const MAX_GENERATIONS = 5000;

@Component({
  components: {},
})
export default class ScenarioGenerator extends Vue {
  private scenario?: Partial<IScenario> = {};
  private rows: Array<CollectionNames> = [];
  private collections: CollectionsModel<IContent> | null = null;
  private categoryNames: ContentCategory[] = [];
  private categories: { [key in ContentCategory]: Array<CollectionNames> } = {} as {
    [key in ContentCategory]: Array<CollectionNames>;
  };
  private answers: { [key in CollectionNames]: string } = {} as { [key in CollectionNames]: string };
  private neglected: CollectionNames[] = [];
  private pinned: CollectionNames[] = [];
  private generated = false;
  private included = false;
  private narrativeName = '';
  private narrativeText = '';
  private narrative = {} as INarrative;

  @Watch('narrative')
  private narrativeChanged(nar: INarrative) {
    if (!nar) return;
    console.log(`narrativeChanged to ${nar.id}`);
    this.narrativeName = nar.name || '';
    this.narrativeText = nar.narrative || '';
    this.included = nar.included || false;
    if (!nar.components) nar.components = {} as { [key in CollectionNames]: string };
    this.answers = Object.assign({}, nar.components);
    this.pinned = Object.keys(this.answers) as CollectionNames[];
  }

  constructor() {
    super();
  }

  private async init() {
    this.$store.states.map(s => {
      this.scenario = s.scenarios.current;
      this.rows.length = 0;
      CollectionNamesArr.forEach(n => {
        this.rows.push(n);
      });
      this.categories =
        this.scenario && this.scenario.categories
          ? this.scenario.categories
          : ({} as { [key in ContentCategory]: Array<CollectionNames> });
      this.categoryNames = Object.keys(this.categories || []) as ContentCategory[];
      this.collections = s;
      this.narrative = s.app.narrative;
    });
  }

  private getCategoryRows(cat: ContentCategory): CollectionNames[] {
    return this.rows.filter(r => this.categories[cat].includes(r));
  }

  private getRandom(cat: CollectionNames): string {
    if (!this.collections) return 'None';
    const list = this.collections[cat].list;
    if (!list || list.length === 0) {
      return 'None';
    } else {
      const r = random(list.length - 1);
      const lr = list[r];
      return lr && lr.id ? lr.id : 'None';
    }
  }

  private newNarrative() {
    this.narrativeText = '';
    this.answers = {} as { [key in CollectionNames]: string };
    this.neglected.length = 0;
    this.pinned.length = 0;
  }

  private togglePinned(cat?: CollectionNames) {
    if (!cat) {
      // All
      if (this.pinned.length > 0) {
        this.pinned.splice(0, this.pinned.length);
      } else {
        this.pinned.splice(0, this.pinned.length);
        this.rows.forEach(r => this.pinned.push(r));
      }
    } else {
      // Single
      const idx = this.pinned.indexOf(cat);
      if (idx >= 0) {
        this.pinned.splice(idx, 1);
      } else {
        this.pinned.push(cat);
      }
    }
  }

  private toggleNeglected(cat?: CollectionNames) {
    if (!cat) {
      this.neglected.length = 0;
    } else {
      const idx = this.neglected.indexOf(cat);
      if (idx >= 0) {
        this.neglected.splice(idx, 1);
      } else {
        this.neglected.push(cat);
        Vue.delete(this.answers, cat);
      }
    }
  }

  private generateNarrative() {
    let narrativeValid = false;
    let count = 0;
    while (!narrativeValid && count < MAX_GENERATIONS) {
      count += 1;
      for (const c in this.categories) {
        const names: CollectionNames[] = this.categories[c as ContentCategory];
        for (const n in names) {
          const name = names[n];
          if (!this.neglected.includes(name) && !this.pinned.includes(name)) {
            Vue.set(this.answers, name, this.getRandom(name));
          }
        }
      }
      narrativeValid = this.isScenarioValid();
      if (narrativeValid) {
        console.log(`Valid scenario generated in iteration ${count}`);
      } else if (count == MAX_GENERATIONS) {
        console.log(`No valid scenario generated after ${count} iterations. Giving up...`);
        this.$store.actions.notify(this.$t(`APP.NO_VALID_SCENARIO`, { count: count }).toString());
        const newAnswers = this.pinned.reduce((acc, cur) => {
          acc[cur] = this.answers[cur];
          return acc;
        }, {} as { [key in CollectionNames]: string });
        this.answers = newAnswers;
      }
    }
    this.generated = !this.generated;
  }

  private isScenarioValid(): boolean {
    const inconsistencies = this.scenario && this.scenario.inconsistencies ? this.scenario.inconsistencies : [];
    const answerIds = Object.values(this.answers).filter(a => !!a);
    const inconsistenciesFound = inconsistencies.filter(i => answerIds.includes(i.ids[0]) && answerIds.includes(i.ids[1]));
    // Always invalidate totally incompatible combinations,
    // and invalidate 85% of partly incompatible combinations (less likely = 100 - 85 = 15%).
    console.log(inconsistenciesFound);
    const finalInconsistencyFound = inconsistenciesFound.some(
      i => i.type === 'totally' || (i.type === 'partly' && Math.random() > 0.15)
    );
    console.log(finalInconsistencyFound);
    return !finalInconsistencyFound;
  }

  private async saveNarrative() {
    console.log('Pin narrative');
    if (!this.scenario) return;
    if (!this.scenario.narratives) {
      this.scenario.narratives = [];
    } else {
      this.scenario.narratives = this.scenario.narratives.filter(n => n.id != this.narrativeName);
    }
    let temp = {} as { [key in CollectionNames]: string | undefined };
    let answerObject = CollectionNamesArr.reduce((prev, cur) => ((prev[cur] = undefined), prev), temp);
    answerObject = Object.assign(answerObject, this.answers);
    const n: INarrative = {
      id: this.narrativeName,
      name: this.narrativeName,
      components: answerObject as { [key in CollectionNames]: string },
      narrative: this.narrativeText,
      included: this.included,
    };
    this.scenario.narratives.push(n);
    this.$store.actions['scenarios'].save(this.scenario);
    this.scenario.id && this.$store.actions['scenarios'].load(this.scenario.id);
    this.$store.actions.changeNarrative(n);
  }

  private getTooltip(cat: CollectionNames) {
    const collection = this.collections && this.collections[cat];
    const ans = this.answers[cat];
    const selected = collection && ans && collection.list && collection.list.filter(i => i.id === ans).pop();
    return (selected && selected.desc) || '';
  }

  private copyToClipboard() {
    const state = this.$store.states();
    const scenario = state.scenarios.current;
    const categories = scenario && scenario.categories;
    const categoryNames = categories && (Object.keys(categories) as ContentCategory[]);
    const narrative = state.app.narrative;

    if (!categoryNames || !categories || !narrative) return;

    const headers = `|${capitalize(this.$tc('APP.DIMENSION'))}|${capitalize(this.$tc('APP.SELECTED'))}|`;
    const format = '|-----|-----|';
    const content = categoryNames
      .map(categoryName => {
        const category = categories[categoryName];
        const components = narrative.components;
        const tbody = category
          .map(c => {
            const ct = state[c] as CollectionType<IContent>;
            const component = ct && ct.list && ct.list.filter(i => i.id === components[c]).shift();
            return component && `| ${capitalize(this.$tc(`COMP.${c.toUpperCase()}`))} | ${component.name} |`;
          })
          .join('\n');
        return `
${headers}
${format}
${tbody}`;
      })
      .join('\n\n');

    const md = `${content}`;
    const html = render(md);

    function listener(e: ClipboardEvent) {
      if (!e.clipboardData) return;
      e.clipboardData.setData('text/html', htmlTemplate({ body: html, css: cssTable }));
      e.clipboardData.setData('text/plain', md);
      e.preventDefault();
    }
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  mounted(): void {
    console.log(`ScenarioGenerator mounted`);
    this.init();
  }
}
